module.exports = ".error-image{width:42rem}.error-message{margin-bottom:2.5rem}"